import "./AwasarPage.css";

function AwasarPage() {
  return (
    <div className="awasar-page">
      <div className="awasar-page__content">अहिले कुनै अवसर उपलब्द छैन</div>
    </div>
  );
}

export default AwasarPage;
